import Vue from 'vue'
import env from '../../../config/prod.env.js'

const state = {
  users: [],
  usercategories: [],
  team: [],
  collabs: [],
  collabsInformation: []
}

const mutations = {
  SET_USERS (state, payload) {
    state.process = payload
  },
  GET_USERS (state, payload) {
    state.users = payload
  },
  SET_USERCATEGORIES (state, payload) {
    state.usercategories = payload
  },
  SET_TEAM (state, payload) {
    state.team = payload
  },
  SET_COLLABS (state, payload) {
    state.collabs = payload
  },
  API_FAILURE (state, payload) {
    throw {error: true, payload: payload.body}
  },
  SET_COLLABS_PLAN (state, payload) {
    state.collabsInformation = payload
  }
}

const actions = {
  myTeam: (context, id) => {
    return Vue.http.get(`${env.API}/api/user/my-team/${id}`)
      .then((response) => {
        context.commit('SET_TEAM', response.body.message)
        return response.body.message
      })
      .catch((error) => {
        return context.commit('API_FAILURE', error)
      })
  },
  myCollabs: (context, id) => {
    return Vue.http.get(`${env.API}/api/user/my-collabs/${id}`)
      .then((response) => {
        context.commit('SET_COLLABS', response.body.message)
        return response.body.message
      })
      .catch((error) => {
        return context.commit('API_FAILURE', error)
      })
  },
  myTools: (context, plan) => {
    return Vue.http.get(`${env.API}/api/user/my-tools/${plan}`)
      .then((response) => {
        return response.body
      })
      .catch((error) => {
        return context.commit('API_FAILURE', error)
      })
  },
  objectivesInPlan: (context, data) => {
    const { plan, user_id } = data
    return Vue.http.get(`${env.API}/api/user/objectives/${plan}/${user_id}`)
      .then((response) => {
        return response.body
      })
      .catch((error) => {
        return context.commit('API_FAILURE', error)
      })
  },
  commitmentsAssociated: (context, data) => {
    let query = '?'        
    if (data.pagination) {
      query += `page=${data.pagination.page}&records=${data.pagination.perPage}`      
    } else {          
      query = ''
    }
    return Vue.http.get(`${env.API}/api/user/commitments/${data.id}${query}`)
      .then((response) => {
        return response.body.message
      })
      .catch((error) => {
        return context.commit('API_FAILURE', error)
      })
  },
  pendingPersonalCommitments: (context, data) => {
    let query = '?'        
    if (data.pagination) {
      query += `page=${data.pagination.page}&records=${data.pagination.perPage}`      
    } else {          
      query = ''
    }
    return Vue.http.get(`${env.API}/api/user/pendings-pcs/${data.id}${query}`)
      .then((response) => {
        return response.body.message
      })
      .catch((error) => {
        return context.commit('API_FAILURE', error)
      })
  },
  personalCommitmentsByTracings: (context, id) => {
    return Vue.http.get(`${env.API}/api/user/personal-commitments-tracing/${id}`)
      .then((response) => {
        return response.body
      })
      .catch((error) => {
        return context.commit('API_FAILURE', error)
      })
  },
  personalCommitmentsByCatSubcat: (context, id) => {
    return Vue.http.get(`${env.API}/api/user/personal-commitments-catsubcat/${id}`)
      .then((response) => {
        return response.body
      })
      .catch((error) => {
        return context.commit('API_FAILURE', error)
      })
  },
  collabsWeekInformation: (context, id) => {
    return Vue.http.get(`${env.API}/api/user/collabs-week-information/${id}`)
      .then((response) => {
        context.commit('SET_COLLABS_PLAN', response.body.collabInformation)
        return response.body.totalPlans
      })
      .catch((error) => {
        return context.commit('API_FAILURE', error)
      })
  },
  getUsers: (context, id) => {
    return Vue.http.get(`${env.API}/api/user`)
      .then((response) => {
        context.commit('GET_USERS', response.body.message)
        return response.body.message
      })
      .catch((error) => {
        return context.commit('API_FAILURE', error)
      })
  },
  updateUser: (context, data) => {
    const { id } = data
    return Vue.http.put(`${env.API}/api/user/${id}`, data)
      .then((response) => {
        context.commit('SET_USERS', response.body)
        return response.body
      })
      .catch((error) => {
        return context.commit('API_FAILURE', error)
      })
  },
  activateUser: (context, data) => {
    const { id } = data
    return Vue.http.put(`${env.API}/api/user/activate/${id}`, data)
      .then((response) => {
        context.commit('SET_USERS', response.body.message)
        return response.body.message
      })
      .catch((error) => {
        return context.commit('API_FAILURE', error)
      })
  },
  insertUser: (context, data) => {
    return Vue.http.post(`${env.API}/api/user`, data)
      .then((response) => {
        context.commit('SET_USERS', response.body.message)
        return response
      })
      .catch((error) => {
        return context.commit('API_FAILURE', error)
      })
  },
  getUserById: (context, id) => {
    return Vue.http.get(`${env.API}/api/user/${id}`)
      .then((response) => {
        // context.commit('GET_USER', response.body.message)
        return response.body.message
      })
      .catch((error) => {
        return context.commit('API_FAILURE', error)
      })
  },
  getRoles: (context, id) => {
    return Vue.http.get(`${env.API}/api/role/list`, id)
      .then((response) => {
        // context.commit('GET_USERS', response.body.message)
        return response.body.message
      })
      .catch((error) => {
        return context.commit('API_FAILURE', error)
      })
  },
  generateReport: (context) => {
    return Vue.http.get(`${env.API}/api/user/report`)
      .then((response) => {
        return response
      })
      .catch((error) => {
        return context.commit('API_FAILURE', error)
      })
  },
  kpiLiderReport: (context, data) => {
    return Vue.http.get(`${env.API}/api/kpi-leader/report/${data.year}/${data.week}`)
      .then((response) => {
        return response
      })
      .catch((error) => {
        return context.commit('API_FAILURE', error)
      })
  },
  updateIca: (context, data) => {
    return Vue.http.put(`${env.API}/api/user/update/ica/user`, data)
      .then((response) => {
        return response.body.message
      })
      .catch((error) => {
        return context.commit('API_FAILURE', error)
      })
  },
  getUserByRut: (context, rut) => {
    return Vue.http.get(`${env.API}/api/user/by-rut/${rut}`)
      .then((response) => {
        // context.commit('GET_USER', response.body.message)
        return response.body.message
      })
      .catch((error) => {
        return context.commit('API_FAILURE', error)
      })
  },
  getLeaders: (context) => {
    return Vue.http.get(`${env.API}/api/user/leaders/select/year/week/`)
      .then((response) => {
        return response.body.message
      })
      .catch((error) => {
        return context.commit('API_FAILURE', error)
      })
  },
  existsUserByRut: (context, data) => {
    return Vue.http.get(`${env.API}/api/user/exists-by-rut/${data.rut}/id/${data.id}`)
      .then((response) => {
        // context.commit('GET_USER', response.body.message)
        return response.body
      })
      .catch((error) => {
        return context.commit('API_FAILURE', error)
      })
  },
  CollabsLidersReport: (context, data) => {
    return Vue.http.post(`${env.API}/api/user/report-collabs-users`, data)
      .then((response) => {
        // context.commit('GET_USER', response.body.message)
        return response
      })
      .catch((error) => {
        return context.commit('API_FAILURE', error)
      })
  },
  CommitmentsPendReport: (context, data) => {
    return Vue.http.post(`${env.API}/api/user/report-commitment-pend`, data)
      .then((response) => {
        // context.commit('GET_USER', response.body.message)
        return response
      })
      .catch((error) => {
        return context.commit('API_FAILURE', error)
      })
  },
  getKpiextByUserId: (context, id) => {
    return Vue.http.get(`${env.API}/api/user/kpi-ext/by/user/${id}`)
      .then((response) => {
        return response.body.message;
      })
      .catch((error) => {
        return context.commit('API_FAILURE', error);
      })
  },
  massiveUserUpload: (context, data) => {
    return Vue.http.post(`${env.API}/api/user/massive`, data)
      .then((response) => {
        return response.body.message;
      })
      .catch((error) => {
        return context.commit('API_FAILURE', error);
      });
  }
}

const filterEnabledUsers = users =>
  users.filter(u => !u.isDeleted)

const getters = {
  getProcess: (state) => state.process,
  getUserCategories: (state) => state.usercategories,
  getMyTeam: (state) => filterEnabledUsers(state.team),
  getMyCollabs: (state) => filterEnabledUsers(state.collabs),
  getMyCollabsInformation: (state) => filterEnabledUsers(state.collabsInformation),
  getUsers: (state) => filterEnabledUsers(state.users)
}

export const user = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/user.js